import React from "react";

import DataTable from "../ui/DataTable";
import Badge from "../ui/Badge";
import Button from "../ui/Button";

function getStatusTone(status) {
  const value = String(status || "").toLowerCase();

  if (value === "completed") return "success";
  if (value === "failed") return "danger";
  if (value === "processing" || value === "running") return "info";

  if (
    value === "uploaded" ||
    value === "queued" ||
    value === "pending"
  ) {
    return "warning";
  }

  return "neutral";
}

export default function DocumentsTable({
  documents = [],
  onAnalyzeDocument
}) {
  const columns = [
    {
      key: "createdAt",
      label: "Date",
      render: (doc) =>
        doc.createdAt
          ? new Date(doc.createdAt).toLocaleDateString()
          : "-"
    },
    {
      key: "companyName",
      label: "Company",
      render: (doc) => doc.companyName || "-"
    },
    {
      key: "originalName",
      label: "Document",
      render: (doc) => doc.originalName || "-"
    },
    {
      key: "category",
      label: "Category",
      render: (doc) => doc.category || "-"
    },
    {
      key: "reportingYear",
      label: "Year",
      render: (doc) => doc.reportingYear || "-"
    },
    {
      key: "tags",
      label: "Tags",
      render: (doc) =>
        Array.isArray(doc.tags) && doc.tags.length
          ? doc.tags.join(", ")
          : "-"
    },
    {
      key: "analysisStatus",
      label: "Analysis",
      render: (doc) => {
        const status = doc.analysisStatus || "Pending";

        return (
          <Badge tone={getStatusTone(status)}>
            {status}
          </Badge>
        );
      }
    },
    {
      key: "storage",
      label: "Storage",
      render: (doc) =>
        doc.blobUrl ? (
          <span title="Stored securely in Azure Blob Storage">
            Secure document
          </span>
        ) : (
          "-"
        )
    },
    {
      key: "actions",
      label: "Actions",
      render: (doc) => (
        <Button
          size="sm"
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation();
            onAnalyzeDocument?.(doc);
          }}
        >
          Analyze
        </Button>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={documents}
      emptyTitle="No documents uploaded"
      emptyMessage="Upload your first sustainability document to begin building your ESG evidence library."
    />
  );
}